var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserInfo = function SvgUserInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7.5C4.5 3.35787 7.85787 0 12 0C16.1421 0 19.5 3.35787 19.5 7.5C19.5 11.6421 16.1421 15 12 15C7.85787 15 4.5 11.6421 4.5 7.5ZM12 3C9.51473 3 7.5 5.01473 7.5 7.5C7.5 9.98527 9.51473 12 12 12C14.4854 12 16.5 9.98527 16.5 7.5C16.5 5.01473 14.4854 3 12 3Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00363 27C3.11657 23.6672 5.85395 21 9.21429 21H10.5C11.3284 21 12 20.3284 12 19.5C12 18.6716 11.3284 18 10.5 18H9.21429C4.12538 18 0 22.1255 0 27.2144C0 28.7528 1.24721 30 2.78571 30H12C12.8285 30 13.5 29.3284 13.5 28.5C13.5 27.6716 12.8285 27 12 27H3.00363Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 30C26.6421 30 30 26.6421 30 22.5C30 18.3579 26.6421 15 22.5 15C18.3579 15 15 18.3579 15 22.5C15 26.6421 18.3579 30 22.5 30ZM21.768 18.372C21.576 18.556 21.48 18.784 21.48 19.056C21.48 19.328 21.576 19.556 21.768 19.74C21.96 19.924 22.188 20.016 22.452 20.016C22.716 20.016 22.94 19.924 23.124 19.74C23.316 19.556 23.412 19.328 23.412 19.056C23.412 18.784 23.316 18.556 23.124 18.372C22.94 18.18 22.716 18.084 22.452 18.084C22.188 18.084 21.96 18.18 21.768 18.372ZM21.792 20.904H21.66V25.632C21.66 25.888 21.704 26.104 21.792 26.28C21.888 26.448 22.008 26.588 22.152 26.7C22.304 26.804 22.468 26.88 22.644 26.928C22.828 26.976 23.012 27 23.196 27H23.268V22.308C23.268 21.82 23.124 21.464 22.836 21.24C22.556 21.016 22.208 20.904 21.792 20.904Z",
    fill: "#828282"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/userInfo.a6ff1304.svg";
export { ForwardRef as ReactComponent };